module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_6-a3d7b50d715929e9e2aa4b7fd83e7576.jpg";